import React from "react";
import { Button, Grid, InputAdornment, makeStyles, TextField, Typography, } from "@material-ui/core";
import Spei from "../../assets/logos/Spei";
import { Translate as T } from "react-localize-redux";
import { useStateCheckoutTransferAccendo } from "./state/useStateCheckoutTransferAccendo";
import { Mail, User } from "react-feather";
import KPayCheck from "../commons/KPayCheck/KPayCheck";
import { useCheckoutContext } from "../../context/useCheckoutContext";
import { CurrencyEnum } from "../../shared/constants/CurrencyEnum";
import TermsConditions from "../commons/TermsConditions/TermsConditions";
var useStyles = makeStyles(function (theme) { return ({
    boxSpei: {
        marginTop: theme.spacing(7),
    },
    gridRoot: {
        paddingBottom: "10px",
        paddingLeft: "14px",
        paddingRight: "14px",
        paddingTop: "10px",
    },
    text: {
        textAlign: "center",
    },
    button: {
        "&.Mui-disabled": {
            backgroundColor: "#023365",
            color: "#FFFFFF",
        },
    },
}); });
export var CheckoutTransferAccendo = function () {
    var _a;
    var classes = useStyles();
    var _b = useCheckoutContext(), isMobile = _b.isMobile, readOnly = _b.readOnly, enableKpay = _b.enableKpay;
    var _c = useStateCheckoutTransferAccendo(), form = _c.form, handleKpayEnable = _c.handleKpayEnable, handleSubmit = _c.handleSubmit, amount = _c.amount, handleTermsModal = _c.handleTermsModal, termsModal = _c.termsModal, emailKpay = _c.emailKpay, kpayEnable = _c.kpayEnable;
    return (React.createElement("form", { onSubmit: form.handleSubmit(handleSubmit) },
        React.createElement(Grid, { container: true, spacing: 2, className: classes.gridRoot },
            React.createElement(Grid, { item: true, xs: 12, md: 2, lg: 2 },
                React.createElement(Spei, null)),
            React.createElement(Grid, { item: true, xs: 12, md: 10, lg: 10, className: !isMobile ? classes.boxSpei : "" },
                React.createElement(Typography, null,
                    React.createElement(T, { id: "spei.description" }))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(TextField, { fullWidth: true, "aria-current": true, name: "name", inputRef: form.register({
                        required: {
                            message: (React.createElement(T, { id: "form.fieldRequired" })),
                            value: true,
                        },
                    }), error: !!form.errors.name, helperText: !!form.errors["name"] && form.errors["name"].message, placeholder: "Nombre y Apellido", InputProps: {
                        startAdornment: (React.createElement(InputAdornment, { position: "start" },
                            React.createElement(User, { color: "#6D7781", size: 18 }))),
                    }, variant: "outlined" })),
            React.createElement(Grid, { item: true, xs: 12 }, !emailKpay && (React.createElement(TextField, { fullWidth: true, "aria-current": true, name: "email", inputRef: form.register({
                    required: {
                        message: (React.createElement(T, { id: "form.fieldRequired" })),
                        value: true,
                    },
                }), error: !!form.errors.email, helperText: !!form.errors["email"] && ((_a = form.errors["email"]) === null || _a === void 0 ? void 0 : _a.message), placeholder: "Email", InputProps: {
                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                        React.createElement(Mail, { color: "#6D7781", size: 18 }))),
                }, variant: "outlined" }))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(TermsConditions, { form: form, open: termsModal, setOpenTerms: handleTermsModal })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Button, { className: classes.button, disabled: readOnly, type: "submit", variant: "contained", fullWidth: true, color: "primary" },
                    React.createElement(T, { id: "payButton" }),
                    " ",
                    amount.total,
                    CurrencyEnum.MXN)),
            enableKpay && (React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(KPayCheck, { isChecked: kpayEnable, handlerChange: handleKpayEnable }))))));
};
